import DocumentsEmpty from "../../shared/Icons/DocumentsEmpty";
import { themeAtom } from "../../shared/atoms";
import { useAtomValue } from "jotai";
import { twMerge } from "tailwind-merge";

export function CertificatesTablePlaceholder() {
  const theme = useAtomValue(themeAtom);

  return (
    <div className={twMerge("flex h-full w-full items-center justify-center", theme.home.tailwind.panelBackground)}>
      <DocumentsEmpty
        className="h-[161px] w-[161px]"
        circleColor={theme.certDocumentIcon.circle}
        primaryColor={theme.certDocumentIcon.primary}
        secondaryColor={theme.certDocumentIcon.secondary}
        tertiaryColor={theme.certDocumentIcon.tertiary}
      />
    </div>
  );
}
